/**
 * @generated SignedSource<<caa4b22f5701f01b0173cb04d8131be7>>
 * @relayHash 17bbe4b04616ea71b8db252ae5b86096
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID abc20a62cdcad314abe59795d23ce5b6f86d86d2dcc8af596a36a3d708248a53

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildsScreenNewQuery$variables = Record<PropertyKey, never>;
export type GuildsScreenNewQuery$data = {
  readonly viewer: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"SponsorsSection_query">;
};
export type GuildsScreenNewQuery = {
  response: GuildsScreenNewQuery$data;
  variables: GuildsScreenNewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildsScreenNewQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "SponsorsSection_query"
      },
      (v1/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GuildsScreenNewQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 2
          }
        ],
        "concreteType": "GuildSponsorshipsConnection",
        "kind": "LinkedField",
        "name": "sponsorships",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GuildSponsorshipsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GuildSponsorship",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rowId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "webUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "lightModeImage",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "transform",
                            "value": {
                              "dpr": 3,
                              "fit": "contain",
                              "fo": "left",
                              "h": 80,
                              "w": 150
                            }
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "transformUrl",
                        "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"contain\",\"fo\":\"left\",\"h\":80,\"w\":150})"
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Guild",
                    "kind": "LinkedField",
                    "name": "guild",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "sponsorships(first:2)"
      },
      (v1/*: any*/)
    ]
  },
  "params": {
    "id": "abc20a62cdcad314abe59795d23ce5b6f86d86d2dcc8af596a36a3d708248a53",
    "metadata": {},
    "name": "GuildsScreenNewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cefa2f6802e22788b5b6596ac137d684";

export default node;
